export default __webpack_public_path__ + "images/93482d6aa7a445a098b09b90afab8729.svg";